export default __webpack_public_path__ + "static/media/arcade-tag-bg.e6eded9f.svg";